import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const newsArticles = articles.filter((a) => a.categorySlug === 'news').slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-800 mb-3">
            最新消息
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            最新動態
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {newsArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
        {newsArticles.length === 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.slice(4, 7).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}